module.exports = __webpack_public_path__ + "img/userCount.aff4674a.svg";